rdefine("ag/main",['backbone','text!ag/main.html', 'ag/collections/smallGallery','ag/gallery'],function(Backbone,template,smallGallery,GalleryModal) {

    var imageLi = Backbone.Ribs.View.extend({
        tagName:'li',
        bindings:{
            'el':{
                css: {
                    'background-image': {
                        data: 'model.url',
                        processor: function (url) {
                            return "url('"+url.replace("0x0","200x200")+"')";
                        }
                    }
                }
            }
        },
        initialize:function(){
            this.$el.fadeIn();
        }
    });

    return Backbone.Ribs.View.extend({
        group_id: 0,
        col:null,
        bindings:{
            'ul':{
                collection:{
                    col:'col',
                    view:imageLi
                },
                toggle:{
                    data:'model.small',
                    processor:function(a) { return a;}
                }
            },
            '.no-images':{
                toggle:{
                    data:'model.small',
                    processor:function(a) { return !a;}
                }
            },
            input: {
                value:'model.group_id'
            }
        },
        events:{
            "click button":"openGalleryModal"
        },
        initialize:function(options) {
            this.model = new Backbone.Ribs.Model({small:0});
            this.group_id = options.group_id ? options.group_id : 0;
            this.model.set("group_id",this.group_id);
            this.$el.html(Template7.compile(template)({group_id:this.group_id}));
            this.col = new smallGallery([],{group_id:this.group_id});

            this.col.on("add remove reset", function(){
                this.model.set("small",this.col.length);
            }.bind(this));
            $.getJSON("/frontend/api/ajax-gallery",{group_id:this.group_id,small:true}, function(resp){
                this.group_id = resp.group_id;
                this.model.set({group_id:this.group_id});
                this.col.group_id = this.group_id;
                    this.col.reset(resp.medias);
            }.bind(this));
            //this.col.loadSmall();
            //load small gallery
        },
        reload:function(){
            $.getJSON("/frontend/api/ajax-gallery",{group_id:this.group_id,small:true}, function(resp){
                this.group_id = resp.group_id;
                this.model.set({group_id:this.group_id});
                this.col.group_id = this.group_id;
                this.col.reset(resp.medias);
            }.bind(this));
        },
        openGalleryModal:function(e){
            e.preventDefault();
            $(e.target).blur();
            var modal = new GalleryModal({group_id:this.group_id});
            modal.done = function() {
                this.reload();
            }.bind(this);
            modal.show();
            return false;
        }
    });
});